import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';


@Component({
  selector: 'app-infodialog',
  templateUrl: './infodialog.component.html',
  styleUrls: ['./infodialog.component.css']
})
export class InfodialogComponent {

  constructor( public dialogRef: MatDialogRef<InfodialogComponent>, private _formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA)
      public data: any
    ) { }

    public output:String;
    public stepone:Boolean;
    public task:Number;
    public firstFormGroup: FormGroup;
    public secondFormGroup: FormGroup;

    onNoClick(): void {
      this.dialogRef.close();
    }

    ngOnInit() {
      // will log the entire data object
      console.log(this.data)
      this.output = this.data.output;
      this.stepone = this.data.stepone;
      this.task = this.data.task;

      this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ['', Validators.required]
    });

    }
}
